

import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import axios from 'axios'
import VueAxios from 'vue-axios'

import formulariosModule from '@/store/formularios'

import VeeValidate, {Validator} from 'vee-validate';
import validatorEs from '@/validator/es';
import validatorEn from '@/validator/en';

import messages from '@/translations';

import {langdetector} from '@/langdetector';

//SET IDIOMA
localStorage.setItem('language', langdetector());

export const store = new Vuex.Store({
  state :{
    language: 'es',
    server : 'https://mailservice.doubledot.es',
    loading: false
  },
  actions :{
    changeLanguage : ({commit}, actualLang) => {
      return new Promise((resolve, reject) => {
        let nextLang = (actualLang == "es") ? "en" : "es";
        commit('setLanguage', nextLang);
        switch (nextLang) {
          case "es":
          Validator.localize('es', validatorEs);
          break;
          case "en":
          Validator.localize('en', validatorEn);
          break;
        }
        resolve(nextLang);
      });
    },
    setLoading : ({commit}, status) => {
      commit('setLoadingstatus', status);
    }
  },
  getters : {
    getLanguage : state => state.language,
    getServer : state => state.server,
    isLoading : state => state.loading,
    getTexts : state => {
      return messages[state.language];
    }
  },
  mutations : {
    setLanguage (state, lang){
      state.language = lang;
      localStorage.setItem('language', lang);      
    },
    setLoadingstatus(state, status){
      state.loading = status;
    }
  },
  modules :{
    formulariosModule
  }
});




// WEBPACK FOOTER //
// ./src/store/store.js